/*
  Le matériel propre à un stage (13/10/2026) : ce que la fiche du stage
  saisit, une ligne par élément, et que le courriel d'avant-stage reprend
  sous chaque enfant inscrit (`stages.materiel_a_prevoir`).

  La base refuse une ligne vide ; la fiche les retire avant d'enregistrer.

  Pur, donc testé à part (__tests__/materiel.test.ts).
*/

/** Le texte de la zone de saisie → les lignes enregistrées : sans blancs, sans vide, sans doublon. */
export function lignesDeMateriel(texte: string): string[] {
  const vues = new Set<string>();
  const lignes: string[] = [];
  for (const brute of texte.split(/\r?\n/)) {
    const ligne = brute.replace(/^\s*[-•*]\s*/, '').trim();
    const cle = ligne.toLocaleLowerCase('fr');
    if (ligne && !vues.has(cle)) {
      vues.add(cle);
      lignes.push(ligne);
    }
  }
  return lignes;
}

/** Les lignes enregistrées → le texte de la zone de saisie. */
export function texteDeMateriel(lignes: string[] | null | undefined): string {
  return (lignes ?? []).join('\n');
}
